import { useQuery } from "react-query";
import { getAccountFinancials } from "../../../api/services";

export const useAccountFinancials = (accountNumber: string) => {
  return useQuery(
    ["accounts/financials", accountNumber],
    getAccountFinancials,
    { enabled: !!accountNumber },
  );
};
